import { Injectable } from "@angular/core";
import { CmsService, PageDescriptionResolver, PageHeadingResolver, PageMeta, PageMetaResolver, PageTitleResolver, PageType, RoutingService, TranslationService } from "@spartacus/core";
import { combineLatest, Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class UigContentSearchMetaResolver extends PageMetaResolver implements PageTitleResolver {

    constructor(
        // protected routingService: RoutingService,
        // protected translationService: TranslationService,
        // protected cms: CmsService
    ) {
        super();
        this.pageType = PageType.CONTENT_PAGE;
        this.pageTemplate = "ContentPage1Template";
    }

    // resolve(): Observable<PageMeta> {
    //     console.log('RESOLVE')

    //     return this.cms.getCurrentPage().pipe(
    //         switchMap(page =>
    //             combineLatest([
    //                 this.resolveDescription()
    //             ])
    //         ),
    //         map(([description]) => ({ description }))
    //     );
    // }

    resolveTitle(): Observable<string> {
        return new Observable(sub => {
            sub.next('test description');
        });
    }
}